import * as React from 'react'

function SvgItTeamDigitale(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M23.648 24H.352A.353.353 0 010 23.648V.352C0 .158.158 0 .352 0h23.296c.194 0 .352.158.352.352v23.296a.353.353 0 01-.352.352zM5.814 11.792a1.596 1.596 0 100-3.192 1.596 1.596 0 000 3.192zM10 18.994V19h4.418C19.13 19 20 16.685 20 12.253 20 7.93 18.995 6 14.418 6H10v12.994zm4.418-10.702c2.586 0 2.838 1.11 2.838 3.955 0 2.89-.252 4.455-2.838 4.455h-1.756v-8.41h1.756z" />
    </svg>
  )
}

export default SvgItTeamDigitale
